import React, {PureComponent} from 'react';
import Image from 'app/helpers/Image';
import BuyButton from 'app/components/shop/lootboxes/buy_button';
import ShopItemDiscount from './shop_item_discount';
import {goToShopLootbox, goToShopOtherItem} from 'app/utils/app_links';
import {shopLootboxStore} from 'app/store/global';
import {translatedName} from 'app/utils/translations_helper';
import {isUSD} from 'app/utils/ShopItemPriceFormat';
import {otherItemName} from 'app/components/my_profile/artifacts/otherItemName';
import {isLootBox} from 'app/utils/isLootBox';
import {coolOffLootbox} from 'app/utils/isCoolOffActiveFor';
import {isDesktop} from 'app/utils';

export default class ShopItem extends PureComponent {
    state = {popupId: null};

    containerRef = React.createRef();

    moreDetailsHandler = e => {
        e && e.preventDefault();
        const {id, recipe, currency, description, type_shop, isCasinoPage, scrollToTopBlock} = this.props;
        const shouldKeepCasinoFilterPosition = isCasinoPage && !isDesktop();

        if (type_shop === 'lootbox' && recipe) {
            if (shouldKeepCasinoFilterPosition) {
                scrollToTopBlock?.();
            }

            goToShopLootbox(recipe.slug, !isUSD(currency), {isCasinoPage, preventScroll: Boolean(isCasinoPage)});

            if (isCasinoPage && !shouldKeepCasinoFilterPosition) {
                scrollToTopBlock?.();
            }
        }
        if (type_shop === 'other' && description) {
            goToShopOtherItem(id, !isUSD(currency));
        }
    };

    afterBuy = () => {
        const {recipe, type_shop, startAnimationOnNonShopPage} = this.props;

        if (type_shop === 'lootbox' && recipe) {
            shopLootboxStore.updateOpenNowStatus(true);
            startAnimationOnNonShopPage && startAnimationOnNonShopPage();
        }
        this.moreDetailsHandler();
    };

    get gameClass() {
        const {game} = this.props;

        return typeof game === 'string'
            ? (game === '' ? 'game' : 'game_') + game.toLowerCase().replace(/ |:\s*/gu, '_')
            : '';
    }

    nameItem = () => {
        const {recipe, title, type_shop} = this.props;

        if (type_shop === 'lootbox') {
            return translatedName(recipe);
        }
        if (type_shop === 'other') {
            return otherItemName(this.props);
        }
        return title;
    };

    coolOffEnabled = () => {
        const {user, type_shop} = this.props;
        return coolOffLootbox(user) && isLootBox(type_shop);
    };

    render() {
        return <div className="market__lootbox">
            <div className="market__lootbox--img-wrap">
                <div
                    className={`market__lootbox--img ${this.gameClass}`}
                    onClick={this.moreDetailsHandler}
                    ref={this.containerRef}>
                    <span className="market__lootbox--img-span"><Image {...this.props} imageDomain/></span>
                    <ShopItemDiscount {...this.props}/>
                </div>
            </div>
            <div className="market__lootbox--desc">
                <div className="market__lootbox--desc__content">
                    <div className="market__lootbox--title">{this.nameItem()}</div>
                </div>
                <div className="market__lootbox--actions">
                    <BuyButton
                        {...this.props}
                        afterBuy={this.afterBuy}
                        with_confirmation={true}
                        show_loading={false}
                        disabled={this.coolOffEnabled()}
                    />
                </div>
            </div>
        </div>;
    }
}
